import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { db } from "../firebase";
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  doc,
} from "firebase/firestore";

const EmployeesTable = () => {
  const [employees, setEmployees] = useState([]);
  const [employeeName, setEmployeeName] = useState("");
  const [service, setService] = useState("");
  const [employmentType, setEmploymentType] = useState("Long Term"); // Default
  const [salary, setSalary] = useState("");

  const employeesCollectionRef = collection(db, "employees");

  useEffect(() => {
    const getEmployees = async () => {
      const data = await getDocs(employeesCollectionRef);
      setEmployees(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };

    getEmployees();
  }, []);

  const addEmployee = async (e) => {
    e.preventDefault();

    if (!employeeName.trim() || !service.trim() || !salary.trim()) {
      console.error("Please fill in all required fields.");
      return;
    }

    const newEmployee = {
      employeeName,
      service,
      employmentType,
      salary,
    };

    try {
      await addDoc(employeesCollectionRef, newEmployee);
      setEmployees([
        ...employees,
        { ...newEmployee, id: Date.now().toString() },
      ]); // Update local state
      clearForm();
    } catch (error) {
      console.error("Error adding employee:", error);
    }
  };

  const deleteEmployee = async (employeeId) => {
    const employeeDoc = doc(db, "employees", employeeId);
    try {
      await deleteDoc(employeeDoc);
      setEmployees(employees.filter((employee) => employee.id !== employeeId));
    } catch (error) {
      console.error("Error deleting employee:", error);
    }
  };

  const clearForm = () => {
    setEmployeeName("");
    setService("");
    setSalary("");
  };

  return (
    <Container>
      <h2>Employees Table</h2>
      <TableWrapper>
        <table>
          <thead>
            <tr>
              <th>Employee Name</th>
              <th>Service</th>
              <th>Employment Type</th>
              <th>Salary</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {employees.map((employee) => (
              <tr key={employee.id}>
                <td>{employee.employeeName}</td>
                <td>{employee.service}</td>
                <td>{employee.employmentType}</td>
                <td>${employee.salary}</td>
                <td>
                  <DeleteButton onClick={() => deleteEmployee(employee.id)}>
                    Delete
                  </DeleteButton>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </TableWrapper>
      <AddEmployeeForm onSubmit={addEmployee}>
        <Input
          type="text"
          placeholder="Employee Name"
          value={employeeName}
          onChange={(e) => setEmployeeName(e.target.value)}
          required
        />
        <Input
          type="text"
          placeholder="Service"
          value={service}
          onChange={(e) => setService(e.target.value)}
          required
        />
        <Select
          value={employmentType}
          onChange={(e) => setEmploymentType(e.target.value)}
        >
          <option value="Long Term">Long Term</option>
          <option value="Short Term">Short Term</option>
        </Select>
        <Input
          type="number"
          placeholder="Salary"
          value={salary}
          onChange={(e) => setSalary(e.target.value)}
          required
        />
        <AddButton type="submit">Add Employee</AddButton>
      </AddEmployeeForm>
    </Container>
  );
};

// Styled Components (same as ClientsTable, but with DeleteButton)
const Container = styled.div`
  width: 50%; // Adjust as needed
  margin: 20px 0;
  padding: 20px;
  background-color: #171c29;
  border-radius: 20px;
  color: white;
  h2 {
    color: #70a8e7;
    font-weight: 300;
    text-align: center;
    margin-bottom: 20px;
  }
  @media (max-width: 1932px) {
    width: 100%;
  }
`;

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;

  table {
    width: 100%;
    border-collapse: collapse;
    min-width: 800px;

    th,
    td {
      padding: 10px;
      text-align: left;
      border: 1px solid #1c2130;

      button {
        border: none;
        background-color: #20273a;
        color: white;
        padding: 10px;
        border-radius: 10px;
        cursor: pointer;
      }
    }

    th {
      background-color: #20273a;
      color: #70a8e7;
    }
  }
`;

const AddEmployeeForm = styled.form`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  grid-gap: 10px;
`;

const Input = styled.input`
  padding: 15px;
  border: none;
  border-radius: 15px;
  background-color: #3b445c;
  color: white;
  outline: none;
`;

const Select = styled.select`
  padding: 15px;
  border: none;
  border-radius: 15px;
  background-color: #3b445c;
  color: white;
  outline: none;
`;

const AddButton = styled.button`
  padding: 10px 15px;
  font-size: 14px;
  background: #e7e7e7;
  color: #252525;
  border: none;
  border-radius: 15px;
  cursor: pointer;
  font-family: "Comfortaa";
  transition: 0.4s;
  &:hover {
    background: #18812a;
    color: white;
  }
`;

const DeleteButton = styled.button`
  padding: 8px 12px;
  background-color: #d9534f; /* Red */
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  &:hover {
    background-color: #c9302c;
  }
`;

export default EmployeesTable;
